module.exports = __webpack_public_path__ + "bg.4bbfabff208ce0801e53.jpg";


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/crm-soundsgood/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles